export enum TipoLogin {
    Cartorio = 0,
    Cartsys = 1,
    AdminCartorio = 2,
}
